var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0534 8.95536C26.1097 15.142 22.6541 21.8066 16.3712 23.8032C10.0883 25.8279 3.31994 22.4253 1.29229 16.2387C-0.763929 10.0521 2.69166 3.38742 8.97454 1.39083C10.174 0.997141 11.4306 0.800293 12.6872 0.800293C17.8848 0.828414 22.4542 4.11856 24.0534 8.95536ZM12.6872 1.86889C6.6613 1.86889 1.80634 6.67757 1.80634 12.6111C1.80634 18.5446 6.68985 23.3252 12.7157 23.3252C18.7416 23.3252 23.5965 18.5165 23.5965 12.583C23.5965 11.4581 23.4252 10.3614 23.0539 9.29282C21.5974 4.87783 17.3993 1.86889 12.6872 1.86889Z",
    fill: "#E73933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86061 16.5217C7.43223 16.4092 7.06097 16.0717 6.91818 15.6498C6.51836 14.5528 6.40413 9.96808 7.17521 9.06801C7.43223 8.75861 7.8035 8.56171 8.20332 8.53359C10.2881 8.30857 16.7994 8.3367 17.542 8.61797C17.9703 8.75861 18.2845 9.03988 18.4558 9.46179C18.9128 10.5869 18.9128 14.7216 18.3987 15.8186C18.2559 16.0998 18.0275 16.3249 17.7419 16.4655C16.9422 16.9155 8.88872 16.8874 7.86061 16.5217ZM11.202 14.3841L14.9717 12.4433L11.202 10.5025V14.3841Z",
    fill: "#E73933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a3cb57b2bfa472b13b33b72b3b7e8eb4.svg";
export { ForwardRef as ReactComponent };